import {useEffect, useRef} from 'react'
import type {Board} from './black_hole_game'

/** Quiet synthesized cues; enabled only by the player's sound toggle. */
export function useGameSound(board: Board, enabled: boolean) {
    const previous = useRef(board)
    const audio = useRef<AudioContext | null>(null)
    useEffect(() => {
        const moved = board.filled === previous.current.filled + 1
        previous.current = board
        if (!enabled || !moved || typeof AudioContext === 'undefined') return
        try {
            const context = audio.current ??= new AudioContext()
            void context.resume().then(() => {
                if (context.state !== 'running') return
                const oscillator = context.createOscillator()
                const gain = context.createGain()
                const end = board.isGameOver()
                const now = context.currentTime
                oscillator.type = 'sine'
                oscillator.frequency.setValueAtTime(end ? 160 : board.nextMove() > 0 ? 440 : 520, now)
                oscillator.frequency.exponentialRampToValueAtTime(end ? 45 : 300, now + (end ? .7 : .12))
                gain.gain.setValueAtTime(.0001, now)
                gain.gain.exponentialRampToValueAtTime(.045, now + .015)
                gain.gain.exponentialRampToValueAtTime(.0001, now + (end ? .8 : .16))
                oscillator.connect(gain)
                gain.connect(context.destination)
                oscillator.start(now)
                oscillator.stop(now + (end ? .85 : .18))
            }).catch(() => { /* Audio is optional. */ })
        } catch { /* Audio is optional. */ }
    }, [board, enabled])
    useEffect(() => () => { void audio.current?.close().catch(() => {}); audio.current = null }, [])
}
